'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by lyj on 2016/10/19.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FlipCard = require('../FlipCard/FlipCard');

var _FlipCard2 = _interopRequireDefault(_FlipCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListPageMiddleFlip = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ListPageMiddleFlip, _Component);

  function ListPageMiddleFlip() {
    (0, _classCallCheck3.default)(this, ListPageMiddleFlip);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ListPageMiddleFlip).call(this));

    _this.state = {
      flipped: false
    };
    return _this;
  }

  (0, _createClass3.default)(ListPageMiddleFlip, [{
    key: 'mouseOver',
    value: function mouseOver() {
      this.setState({
        flipped: true
      });
    }
  }, {
    key: 'mouseLeave',
    value: function mouseLeave() {
      this.setState({
        flipped: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./ListPageMiddleFlip.scss');
      var data = this.props.data;
      var flipped = this.state.flipped;

      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement('div', { className: styles.link }),
        _react2.default.createElement(
          'div',
          { className: styles.middleBox },
          _react2.default.createElement(
            _FlipCard2.default,
            { onFrontMouseOver: this.mouseOver.bind(this),
              componentMouseLeave: this.mouseLeave.bind(this),
              flipped: flipped },
            _react2.default.createElement(
              'div',
              { className: styles.front },
              _react2.default.createElement('img', { src: data[0],
                alt: '' })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.back },
              _react2.default.createElement('img', {
                src: data[1], alt: '' })
            )
          )
        ),
        _react2.default.createElement('div', { className: styles.link }),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return ListPageMiddleFlip;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.array
}, _temp);
exports.default = ListPageMiddleFlip;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ListPageMiddleFlip/ListPageMiddleFlip.js
 ** module id = 1363
 ** module chunks = 0
 **/